'use client';

import { createContext, useCallback, useContext, useState } from 'react';
import { useRouteHash } from '@/utils/use-route-hash';
interface CategoryModalContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}
const CategoryModalContext = createContext<CategoryModalContextValue | null>(null);
export function useCategoryModal() {
  const ctx = useContext(CategoryModalContext);
  if (!ctx) throw new Error('useCategoryModal must be used inside CategoryModalProvider');
  return ctx;
}
export function CategoryModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const onHashRemoved = useCallback(() => setIsOpen(false), []);
  const {
    addHash,
    removeHash
  } = useRouteHash({
    hash: 'menu',
    replace: false,
    onHashRemoved
  });
  const open = useCallback(() => {
    setIsOpen(true);
    addHash();
  }, [addHash]);
  const close = useCallback(() => {
    setIsOpen(false);
    removeHash();
  }, [removeHash]);
  return <CategoryModalContext.Provider value={{
    isOpen,
    open,
    close
  }} data-sentry-element="unknown" data-sentry-component="CategoryModalProvider" data-sentry-source-file="category-modal-context.tsx">{children}</CategoryModalContext.Provider>;
}